import {checkUndefinedOrDefaultValue} from "@/libs/Helpers";

class CookieSetterGetter {
    constructor(cookiePath) {
        if (cookiePath === null)
            cookiePath = '/';

        this.cookiePath = cookiePath;
    }

    setCookie(name, value, expire_days) {
        let expirationStr = '';
        if (expire_days !== null) {
            let exDate = new Date();
            exDate.setDate(exDate.getDate() + expire_days);
            expirationStr = `; expires=${exDate.toUTCString()}`;
        }

        document.cookie = `${name}=${value}${expirationStr}; path=${this.cookiePath}`;
    }

    getCookie(name) {
        let cookie_name = `${name}=`;
        let decodedCookie = decodeURIComponent(document.cookie);

        let cookie_list = decodedCookie.split(';');
        for (let i = 0; i < cookie_list.length; i++) {
            let c = cookie_list[i].trim();
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(cookie_name) === 0) {
                return c.substring(cookie_name.length, c.length);
            }
        }
        return null;
    }
}

export default new CookieSetterGetter(
    checkUndefinedOrDefaultValue(process.env.VUE_APP_COOKIES_PATH, '/')
);